/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Create a license based on an order previously verified by OrderValidationSerializer.
 * This may be during tenant creation (user activating their first license_number) or into an existing tenant
 * @export
 * @interface LicenseCreationRequest
 */
export interface LicenseCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof LicenseCreationRequest
     */
    signedData: string;
    /**
     * 
     * @type {boolean}
     * @memberof LicenseCreationRequest
     */
    coterminate?: boolean;
}

/**
 * Check if a given object implements the LicenseCreationRequest interface.
 */
export function instanceOfLicenseCreationRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "signedData" in value;

    return isInstance;
}

export function LicenseCreationRequestFromJSON(json: any): LicenseCreationRequest {
    return LicenseCreationRequestFromJSONTyped(json, false);
}

export function LicenseCreationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LicenseCreationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'signedData': json['signed_data'],
        'coterminate': !exists(json, 'coterminate') ? undefined : json['coterminate'],
    };
}

export function LicenseCreationRequestToJSON(value?: LicenseCreationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'signed_data': value.signedData,
        'coterminate': value.coterminate,
    };
}

